import firebase from "../helper/firebase";
import _ from "lodash";

const initialState = {
  myJobs: {},
  myJobsLoading: true,

  jobs: {},
  jobsLoading: true,
  jobsUpdated: 0,

  favorites: {},
  favoritesLoading: true,

  invited: {},
  invitedLoading: true,

  myApplications: {},
  myApplicationsLoading: true,

  myOffers: {},
  myOffersLoading: true,

  commissions: {},
  commissionsLoading: true,

  subscriptions: {},
  subscriptionsLoading: true,

  referred: {},
  referredLoading: true,

  myInvites: {},
  myInvitesLoading: true,

  selectionStages: {},
  selectionStagesLoading: true,

  invites: {},
  invitesLoading: true,
  invitesLength: 0,

  selection: {},
  selectionLoading: true,
  selectionLength: 0,

  applications: {},
  applicationsLoading: true,
  applicationsLength: 0,

  endorsements: {},
  endorsementsLoading: true,
  endorsementsLength: 0,

  chats: {},
  chatsLoading: true,

  offers: {},
  offersLoading: true,
};

//Actions
const UNAUTHENTICATED = "GlobalState/UNAUTHENTICATED";
const SET_SNACK = "GlobalState/SET_SNACK";
const GET_MYJOBS = "JobsState/GET_MYJOBS";
const GET_FAVORITES = "JobsState/GET_FAVORITES";
const GET_SUBSCRIPTIONS = "JobsState/GET_SUBSCRIPTIONS";
const GET_MYAPPLICATIONS = "JobsState/GET_MYAPPLICATIONS";
const GET_MYOFFERS = "JobsState/GET_MYOFFERS";
const GET_INVITED = "JobsState/GET_INVITED";
const GET_COMMISSIONS = "JobsState/GET_COMMISSIONS";
const GET_REFERRED = "JobsState/GET_REFERRED";
const GET_MYINVITES = "JobsState/GET_MYINVITES";
// const UPDATE_JOBS = 'JobsState/UPDATE_JOBS'
const GET_SELECTIONSTAGES = "JobsState/GET_SELECTIONSTAGES";
const GET_INVITE = "JobsState/GET_INVITE";
const GET_SELECTION = "JobsState/GET_SELECTION";
const GET_APPLICATIONS = "JobsState/GET_APPLICATIONS";
const GET_CHATS = "JobsState/GET_CHATS";
const GET_OFFERS = 'JobsState/GET_OFFERS'

const GET_JOB = "JobState/GET_JOB";
export function getJob(jid) {
  return (dispatch, getState) => {
    let jobs = getState().job;
    if (!jobs[jid]) {
      getJobPromise(jid)
        .then(data => dispatch({ type: GET_JOB, payload: data, jid }))
        .catch(error => setSnack(true, error));
    }
  };
}
function getJobPromise(jid) {
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("jobs")
      .doc(jid)
      .get()
      .then(snap => resolve(snap.data()))
      .catch(error => reject(Error(error)));
  });
}

let detachers = [];

export function updateJob(job) {
  return (dispatch, getState) => {
    let jobs = getState().jobs.jobs;
    jobs[job.jid] = { ...jobs[job.jid], ...job };
    dispatch({ type: GET_JOB, payload: jobs });
  };
}

// export async function getJob(jid){
//   const ref = firebase.database().ref();
//   let testjob = await firebase.database().ref(`jobs/${jid}`).once('value').then(snap=>{return snap.val()})
//   console.log(testjob);
// }

function getMyInfo(uid, stateName, dbName, dispatchName, getJobs) {
  return (dispatch, getState) => {
    let data = getState().jobs[stateName];
    let status = getState().jobs[`${stateName}Loading`];
    console.log(status);
    if (!status) {
      console.log(`already have ${stateName}`);
      !!getJobs &&
        Object.keys(data)
          .map(dataId => data[dataId])
          .forEach(item => dispatch(getJob(item.jid)));
      return;
    } else {
      console.log(`dont have ${stateName} yet`);
      dataPromise(`${dbName}/${uid}`)
        .then(snap => {
          snap.val() !== null
            ? dispatch({ type: dispatchName, payload: snap.val() })
            : dispatch({ type: dispatchName, payload: {} });
          snap.val() !== null &&
            !!getJobs &&
            snap.forEach(item => dispatch(getJob(item.val().jid)));
          snap.val() === null &&
            !!getJobs &&
            dispatch({ type: GET_JOB, payload: getState().jobs.jobs });
        })
        .catch(error => {
          console.log(error);
          // dispatch({type: GET_FAIL})
        });
    }
  };
}

export function getMyListener(references) {
  return (dispatch, getState) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        references.forEach(ref => {
          let data = getState().jobs[ref.stateName];
          if (!_.isEmpty(data)) {
            !!ref.getJobs &&
              Object.keys(data)
                .map(dataId => data[dataId])
                .forEach(item => dispatch(getJob(item.jid)));
            return;
          } else {
            detachers.push(
              firebase.database().ref(`${ref.dbName}/${user.uid}`)
            );
            firebase
              .database()
              .ref(`${ref.dbName}/${user.uid}`)
              .on(
                "value",
                snap => {
                  snap.val() !== null
                    ? dispatch({ type: ref.dispatchName, payload: snap.val() })
                    : dispatch({ type: ref.dispatchName, payload: {} });
                  snap.val() !== null &&
                    !!ref.getJobs &&
                    snap.forEach(item => dispatch(getJob(item.val().jid)));
                  snap.val() === null &&
                    !!ref.getJobs &&
                    dispatch({ type: GET_JOB, payload: getState().jobs.jobs });
                },
                err => {
                  console.log(err);
                  // dispatch({type: GET_FAIL})
                }
              );
          }
        });
      } else {
        // detachers.forEach(item=>{
        //   console.log(item);
        //   item.off()
        // })
      }
    });
  };
}

export function getReferences(references) {
  return (dispatch, getState) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        references.forEach(ref => {
          dispatch(
            getMyInfo(
              user.uid,
              ref.stateName,
              ref.dbName,
              ref.dispatchName,
              ref.getJobs
            )
          );
        });
      }
    });
  };
}

function dataPromise(url) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref(`${url}`)
      .once("value")
      .then(snap => resolve(snap))
      .catch(e => reject(Error(e)));
  });
}

export function setSnack(snackStatus, snackMessage) {
  return (dispatch, getState) => {
    let snack = { snackStatus, snackMessage };
    dispatch({ type: SET_SNACK, payload: snack });
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MYJOBS:
      return {
        ...state,
        myJobs: action.payload,
        myJobsLoading: false
      };

    // case GET_JOB:
    //   return {
    //     ...state,
    //     jobs: action.payload,
    //     jobsUpdated:Date.now(),
    //     jobsLoading: false,
    //   }

    case GET_FAVORITES:
      return {
        ...state,
        favorites: action.payload,
        favoritesLoading: false
      };

    case GET_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: action.payload,
        subscriptionsLoading: false
      };

    case GET_MYINVITES:
      return {
        ...state,
        myInvites: action.payload,
        myInvitesLoading: false
      };

    case GET_MYAPPLICATIONS:
      return {
        ...state,
        myApplications: action.payload,
        myApplicationsLoading: false
      };

    case GET_MYOFFERS:
      return {
        ...state,
        myOffers: action.payload,
        myOffersLoading: false
      };

    case GET_INVITED:
      return {
        ...state,
        invited: action.payload,
        invitedLoading: false
      };

    case GET_COMMISSIONS:
      return {
        ...state,
        commissions: action.payload,
        commissionsLoading: false
      };

    case GET_REFERRED:
      return {
        ...state,
        referred: action.payload,
        referredLoading: false
      };

    case GET_SELECTIONSTAGES:
      return {
        ...state,
        selectionStages: action.payload,
        selectionStagesLoading: false
      };

    case GET_INVITE:
      return {
        ...state,
        invites: action.payload,
        invitesLength: Object.keys(action.payload).length,
        invitesLoading: false
      };

    case GET_SELECTION:
      return {
        ...state,
        selection: action.payload,
        selectionLength: Object.keys(action.payload).length,
        selectionLoading: false
      };

    case GET_APPLICATIONS:
      return {
        ...state,
        applications: action.payload,
        applicationsLength: Object.keys(action.payload).length,
        applicationsLoading: false
      };

    case GET_CHATS:
      return {
        ...state,
        chats: action.payload,
        chatsLoading: false
      };

    case GET_OFFERS:
      return {
        ...state,
        offers: action.payload,
        offersLoading: false
      };

    case UNAUTHENTICATED:
      console.log("job/UNAUTHENTICATED");
      return {
        ...initialState,
        authLoading: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/JobsReducer.js